let _components = {
    '.p-footer__btn--update' : {
        linkUrl:'https://bns.plaync.com/board/update/view?articleId=6215919c4fcd590db6c725e8&viewMode=list&size=20',
    },
    '.p-footer__btn--launcher' : {
        linkUrl:'https://bns.plaync.com/download/index',
    },
    '.p-footer__btn--password' : {
        linkUrl:'https://id.plaync.com/recovery/password',
    },
    '.p-footer__btn--signup' : {
        linkUrl:'https://login.plaync.com/nclogin/signup',
    },
};
$.each(_components, function (key, value) {
    if(value.alert){
        $(document).on('click', key, function(e) {
            e.preventDefault();
            promokit.message({
                type: 'alert',
                message: value.alert,
            });
        });
    }
    $(key).attr('data-href', value.id);
    $(key).attr('href', value.linkUrl);
    if(value.linkBlank)
        $(key).attr('target','_blank');
});

promokit.video({
    el: '#player-bg',
    url: 'https://vod.plaync.com/BS/update/220229/BG_index.mp4',
    autoplay: true,
    loop: true
});

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        fixed: false,
        theme:'black'
    },
    headerButton:{
        cookie:{
            type:'year',
            key:'INDEX_WEB_VISIT_bns',
            value:false
        },
        home:true,
        event:false,
        update:true,
        sns:true,
        theme:'black'
    },
});

promokit.preload();
